import { useEffect, useState } from 'react';
import { apiClient } from '@/lib/apiClient';
import { useCart } from '@/features/cart/context/CartContext';
import { Building2, Wallet, ShoppingBag } from 'lucide-react';
import '../customer.css';

// === [FIXED] فرمت‌کننده درصد (حذف اعشار در صورت صحیح بودن) ===
const fmtPercent = (val) => {
    const n = Number(val);
    if (isNaN(n)) return '0٪';
    return n % 1 === 0 ? `${n}٪` : `${parseFloat(n.toFixed(1))}٪`;
};

// === [ADDED] فرمت‌کننده قیمت ===
const fmt = (n) => new Intl.NumberFormat('fa-IR').format(Number(n) || 0);

export default function MyCompanies() {
    const { addToCart } = useCart();
    const [companies, setCompanies] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [addingId, setAddingId] = useState(null);

    useEffect(() => {
        const fetchCompanies = async () => {
            try {
                const { data, error } = await apiClient.GET('/api/v1/customer/profile/my-companies');
                if (error) throw new Error(error.detail || 'خطا در دریافت اطلاعات شرکت‌ها');

                const enriched = await Promise.all((data || []).map(async (company) => {
                    const contracts = await Promise.all((company.contracts || []).map(async (contract) => {
                        try {
                            const { data: itemsData } = await apiClient.GET(
                                `/api/v1/customer/profile/my-companies/${contract.contract_id}/items`
                            );
                            return { ...contract, items: itemsData?.items || [] };
                        } catch {
                            return { ...contract, items: [] };
                        }
                    }));
                    return { ...company, contracts };
                }));
                setCompanies(enriched);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        fetchCompanies();
    }, []);

    const handleAddToCart = async (contract) => {
        if (!contract || !contract.items || contract.items.length === 0) {
            alert('اقلامی برای افزودن وجود ندارد.');
            return;
        }

        setAddingId(contract.contract_id);
        try {
            const isDiscount = contract.contract_type === 'discount';
            const discountPercent = Number(contract.discount_percent) || 0;

            for (const item of contract.items) {
                const qty = item.max_qty || 1;
                const productObj = {
                    id: item.product_id,
                    name_fa: item.product_name,
                    base_price: item.base_price,
                    stock_quantity: 9999,
                    discount_percent: isDiscount ? discountPercent : 0,
                    package_name: isDiscount ? `قرارداد ${contract.company_code}` : null
                };
                await addToCart(productObj, qty);
            }

            if (contract.company_code) {
                sessionStorage.setItem('auto_company_info', JSON.stringify({
                    company_code: contract.company_code,
                    identification_value: contract.identification_value || ''
                }));
            }

            alert('اقلام به سبد خرید اضافه شدند. برای پرداخت به صفحه سبد خرید مراجعه کنید.');
        } catch (e) {
            alert('خطا در افزودن به سبد خرید: ' + e.message);
        } finally {
            setAddingId(null);
        }
    };

    if (loading) return <div style={{ padding: '2rem', textAlign: 'center' }}>در حال دریافت اطلاعات...</div>;
    if (error) return <div style={{ padding: '2rem', textAlign: 'center', color: 'red' }}>{error}</div>;

    return (
        // === [CHANGED] حذف استایل اینلاین از wrapper اصلی ===
        <div className="customer-profile-page customer-companies-page">
            {/* === [CHANGED] حذف استایل اینلاین marginBottom از هدر === */}
            <div className="customer-profile-header">
                <h1 className="customer-profile-title">شرکت‌های من</h1>
            </div>

            {companies.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '3rem', background: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                    <Building2 size={48} color="#94a3b8" style={{ margin: '0 auto 1rem' }} />
                    <p style={{ color: '#64748b' }}>شما در حال حاضر به هیچ شرکتی متصل نیستید.</p>
                </div>
            ) : (
                <div className="customer-company-list" style={{ display: 'grid', gap: '1.5rem' }}>
                    {companies.map((company) => (
                        <div className="customer-company-card" key={company.company_id} style={{ background: '#fff', borderRadius: '12px', border: '1px solid #e5e7eb', padding: '1.5rem', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>

                            {/* هدر شرکت */}
                            <div className="customer-company-header" style={{ display: 'flex', alignItems: 'center', gap: '1rem', borderBottom: '1px solid #f1f5f9', paddingBottom: '1rem', marginBottom: '1rem' }}>
                                <div style={{ background: '#eff6ff', padding: '0.75rem', borderRadius: '50%' }}>
                                    <Building2 size={24} color="#2563eb" />
                                </div>
                                <div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
                                        <h3 style={{ margin: 0, fontSize: '1.2rem', color: '#1e293b' }}>{company.company_name}</h3>
                                        {company.department && (
                                            <span style={{ fontSize: '0.75rem', color: '#64748b', background: '#f1f5f9', padding: '2px 8px', borderRadius: '12px' }}>
                                                {company.department}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <h4 style={{ fontSize: '0.95rem', color: '#475569', marginBottom: '0.75rem' }}>پکیج‌های فروش کالا:</h4>

                            {company.contracts.length === 0 ? (
                                <p style={{ fontSize: '0.9rem', color: '#94a3b8' }}>پکیجی برای شما یافت نشد.</p>
                            ) : (
                                <div className="customer-company-contracts" style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
                                    {company.contracts.map((contract) => {
                                        const isDiscount = contract.contract_type === 'discount';
                                        const discountPercent = Number(contract.discount_percent) || 0;

                                        let totalBase = 0;
                                        let totalFinal = 0;
                                        (contract.items || []).forEach(item => {
                                            const qty = item.max_qty || 1;
                                            const base = (Number(item.base_price) || 0) * qty;
                                            totalBase += base;
                                            totalFinal += isDiscount ? base - (base * discountPercent / 100) : base;
                                        });

                                        const isAddingThis = addingId === contract.contract_id;
                                        const hasItems = (contract.items || []).length > 0;

                                        return (
                                            <div className="customer-company-contract-card" key={contract.contract_id} style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '1rem', flex: '1 1 280px', display: 'flex', flexDirection: 'column' }}>

                                                {/* لیست اقلام سبد */}
                                                <div style={{ flexGrow: 1 }}>
                                                    <div style={{ fontSize: '0.75rem', color: '#64748b', marginBottom: '0.5rem', fontWeight: 'bold' }}>اقلام سبد:</div>
                                                    {!hasItems ? (
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: '#94a3b8', fontSize: '0.85rem' }}>
                                                            <ShoppingBag size={14} /> اقلامی ثبت نشده است
                                                        </div>
                                                    ) : (
                                                        <ul style={{ margin: 0, padding: 0, listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
                                                            {(contract.items || []).map((item, idx) => {
                                                                const qty = item.max_qty || 1;
                                                                const base = (Number(item.base_price) || 0) * qty;
                                                                const final = isDiscount ? base - (base * discountPercent / 100) : base;
                                                                return (
                                                                    <li className="customer-company-contract-item" key={item.product_id || idx} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '0.85rem', padding: '0.35rem 0', borderBottom: '1px solid #f1f5f9' }}>
                                                                        <span className="customer-company-product-name" style={{ color: '#1e293b', flex: 1 }}>{item.product_name}</span>
                                                                        <span style={{ color: '#64748b', margin: '0 0.5rem', whiteSpace: 'nowrap' }}>{qty} ×</span>
                                                                        <span className="customer-company-product-amount" style={{ color: isDiscount ? '#10b981' : '#475569', fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                                                                            {fmt(final)} ریال
                                                                        </span>
                                                                    </li>
                                                                );
                                                            })}
                                                        </ul>
                                                    )}
                                                </div>

                                                {/* بخش پایینی: جمع کل و دکمه */}
                                                {hasItems && (
                                                    <div style={{ flexShrink: 0, marginTop: '0.75rem' }}>
                                                        {/* جمع کل + درصد تخفیف / کیف پول در یک ردیف */}
                                                        <div className="customer-company-contract-total" style={{ borderTop: '1px solid #cbd5e1', paddingTop: '0.75rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '0.85rem' }}>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                                                <span style={{ color: '#64748b' }}>جمع کل:</span>
                                                                {isDiscount ? (
                                                                    <span style={{ fontWeight: 'bold', color: '#10b981', fontSize: '0.8rem' }}>
                                                                        تخفیف {fmtPercent(discountPercent)}
                                                                    </span>
                                                                ) : (
                                                                    <span style={{ display: 'flex', alignItems: 'center', gap: '0.2rem', fontWeight: 'bold', color: '#2563eb', fontSize: '0.8rem' }}>
                                                                        <Wallet size={12} /> کیف پول شرکت
                                                                    </span>
                                                                )}
                                                            </div>
                                                            <span style={{ fontWeight: 'bold', color: isDiscount ? '#10b981' : '#2563eb' }}>
                                                                {fmt(isDiscount ? totalFinal : totalBase)} ریال
                                                                {isDiscount && totalFinal !== totalBase && (
                                                                    <span style={{ color: '#94a3b8', fontSize: '0.75rem', textDecoration: 'line-through', marginRight: '0.5rem', fontWeight: 'normal' }}>
                                                                        {fmt(totalBase)}
                                                                    </span>
                                                                )}
                                                            </span>
                                                        </div>

                                                        {/* دکمه با ارتفاع کاملاً قفل‌شده */}
                                                        <button
                                                            onClick={() => handleAddToCart(contract)}
                                                            disabled={isAddingThis}
                                                            className="btn-primary"
                                                            style={{
                                                                marginTop: '0.75rem',
                                                                padding: '0 1rem',
                                                                fontSize: '0.85rem',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                gap: '0.4rem',
                                                                width: '100%',
                                                                height: '44px',
                                                                minHeight: '44px',
                                                                maxHeight: '44px',
                                                                boxSizing: 'border-box',
                                                                flex: '0 0 44px',
                                                                lineHeight: '1',
                                                                cursor: isAddingThis ? 'not-allowed' : 'pointer',
                                                                opacity: isAddingThis ? 0.6 : 1
                                                            }}
                                                        >
                                                            <ShoppingBag size={16} />
                                                            {isAddingThis ? 'در حال افزودن...' : 'افزودن به سبد خرید'}
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}